export default "__VITE_ASSET__DuAqJPAy__"